// extracted by mini-css-extract-plugin
export default {"GeoareasPage":"GeoareasPage__5T+nJ"};